export const breadcrumbLd = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((it, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    name: it.name,
    ...(it.url ? { item: it.url } : {}),
  })),
});

export function setPageMeta({ title, description, ogType = 'website', url, image, jsonLd }) {
  if (title) document.title = title;

  const upsert = (selector, attrs) => {
    let el = document.head.querySelector(selector);
    if (!el) {
      el = document.createElement('meta');
      document.head.appendChild(el);
    }
    Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
  };

  if (description) {
    upsert('meta[name="description"]', { name: 'description', content: description });
    upsert('meta[property="og:description"]', { property: 'og:description', content: description });
    upsert('meta[name="twitter:description"]', { name: 'twitter:description', content: description });
  }
  if (title) {
    upsert('meta[property="og:title"]', { property: 'og:title', content: title });
    upsert('meta[name="twitter:title"]', { name: 'twitter:title', content: title });
  }
  upsert('meta[property="og:type"]', { property: 'og:type', content: ogType });
  upsert('meta[property="og:site_name"]', { property: 'og:site_name', content: 'ConstructHelp' });
  if (url) {
    upsert('meta[property="og:url"]', { property: 'og:url', content: url });
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', url);
  }
  if (image) {
    upsert('meta[property="og:image"]', { property: 'og:image', content: image });
    upsert('meta[name="twitter:image"]', { name: 'twitter:image', content: image });
    upsert('meta[name="twitter:card"]', { name: 'twitter:card', content: 'summary_large_image' });
  }

  let ld = document.getElementById('page-jsonld');
  if (jsonLd) {
    if (!ld) {
      ld = document.createElement('script');
      ld.type = 'application/ld+json';
      ld.id = 'page-jsonld';
      document.head.appendChild(ld);
    }
    ld.textContent = JSON.stringify(jsonLd);
  } else if (ld) {
    ld.remove();
  }
}
